var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M1.99902 0L7.99902 6L1.99902 12L0.599023 10.6L5.19902 6L0.599023 1.4L1.99902 0Z",
    fill: "#252E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/sliderArrow.682e0e8c032b1f7280fe4c4b36082bdb.svg";
export { ForwardRef as ReactComponent };